import React, { FC } from 'react';
import { IssueDetailContactUs } from './components/IssueDetailContactUs';
import { Elevation } from '../../../components/Elevation';
import classes from './styles/issueDetail.module.scss';
import { PaddingBox } from '../../../components/PaddingBox';
import { isMobile } from '../../../utils/device';
import { IssueDetailAddress } from './components/IssueDetailAddress';

export const IssueDetail: FC = () => {
	return (
		<PaddingBox
			medium={!isMobile}
			tiny={isMobile}
			className={classes.issueDetail}
		>
			<Elevation
				borderRadius='16px'
				boxShadow='small'
				className={classes.detailContainer}
			>
				<IssueDetailContactUs />
				<hr className={classes.separator} />
				<IssueDetailAddress />
			</Elevation>
		</PaddingBox>
	);
};
